/**
 * Singleton store reference.
 * Allows non-component code (hooks, utils) to access dispatch
 * without requiring react-redux v7+ hooks.
 *
 * Usage:
 *   - Call `setStore(store)` once in app.tsx after the store is created.
 *   - Call `getDispatch()` anywhere that needs to dispatch an action.
 */

import { Store } from 'redux';

let _store: Store | null = null;

export function setStore(store: Store) {
  _store = store;
}

export function getDispatch() {
  if (!_store) {
    throw new Error('Redux store has not been initialized. Call setStore(store) in app.tsx first.');
  }
  return _store.dispatch;
}
